import React, { memo, useRef } from "react";
import styled from "styled-components";
import BibleSearchPanel from "../bible_search_panel";
import FontSettingsBlock from "./font_settings_block";
import { FontSettingsIcon } from "../../../../../common/assets/icons";
import VerticalLine from "../../../../../common/assets/icons/vertical_line";
import BibleHistoryIcon from "../../../../../common/assets/icons/bible_page_icons/bible_history_icon";
import BibleHistoryBlock from "./bible_history_block";

const BibleSearchAndSettingsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

const SearchAndSettingsButtonBlock = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  border-radius: 15px;
  ${({ isSearchScreenActive }) =>
    !isSearchScreenActive &&
    `
   background: #fff;
   overflow: hidden;
   box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
   transition: 0.2s;

   &: hover {
     box-shadow: 4.462px 4.462px 7.808px 0px rgba(0, 0, 0, 0.1);
   }
  `}
`;

const SettingsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  transition: 0.2s;
  cursor: pointer;

  :hover {
    svg {
      transition: 0.2s;
      transform: scale(1.1);
    }
  }
`;

const FontSettingsButton = styled(SettingsButton)`
  padding: 0 5px 0 8px;
`;

const HistoryButton = styled(SettingsButton)`
  padding: 0 8px 0 5px;
`;

const VerticalLineStyled = styled(VerticalLine)`
  height: 20px;
`;

const BibleSearchAndSettings = ({
  activeScreenDesktop,
  bibleFontSettings,
  bibleSearchInput,
  expandedSectionName,
  bibleSearchPlace,
  bibleTranslations,
  setBibleFontSettings,
  setActiveScreenDesktop,
  setBibleSearchResults,
  setBibleSearchInput,
  setExpandedSectionName,
  setIsLoading,
  toggleOpenFontSettings,
  toggleOpenBibleHistory,
}) => {
  const historyButtonRef = useRef(null);

  const isSearchScreenActive = activeScreenDesktop === "bible_search";

  return (
    <BibleSearchAndSettingsContainer>
      <SearchAndSettingsButtonBlock isSearchScreenActive={isSearchScreenActive}>
        <BibleSearchPanel
          activeScreenDesktop={activeScreenDesktop}
          bibleSearchInput={bibleSearchInput}
          bibleSearchPlace={bibleSearchPlace}
          setActiveScreenDesktop={setActiveScreenDesktop}
          setBibleSearchResults={setBibleSearchResults}
          setBibleSearchInput={setBibleSearchInput}
          setExpandedSectionName={setExpandedSectionName}
          setIsLoading={setIsLoading}
          isSearchScreenActive={isSearchScreenActive}
        />

        {!isSearchScreenActive && (
          <>
            <VerticalLineStyled />
            <FontSettingsButton onClick={toggleOpenFontSettings}>
              <FontSettingsIcon />
            </FontSettingsButton>
            <HistoryButton
              ref={historyButtonRef}
              onClick={toggleOpenBibleHistory}
            >
              <BibleHistoryIcon />
            </HistoryButton>
          </>
        )}
      </SearchAndSettingsButtonBlock>

      {expandedSectionName === "FONT_SETTINGS" && (
        <FontSettingsBlock
          bibleFontSettings={bibleFontSettings}
          setBibleFontSettings={setBibleFontSettings}
        />
      )}

      {expandedSectionName === "BIBLE_HISTORY" && (
        <BibleHistoryBlock
          bibleTranslations={bibleTranslations}
          historyButtonRef={historyButtonRef}
          toggleOpenBibleHistory={toggleOpenBibleHistory}
        />
      )}
    </BibleSearchAndSettingsContainer>
  );
};

export default memo(BibleSearchAndSettings);
